import React from 'react';
import { Label, Input, FormGroup } from 'reactstrap';
import { string, func } from 'prop-types';

const propTypes = {
  deepLink: string,
  onDeepLinkChange: func,
};
const defaultProps = {
  deepLink: '',
};

const FlowDeepLink = ({ deepLink, onDeepLinkChange }) => (
  <FormGroup className="form-group-upper-label">
    <Label for="flow-deeplink">DeepLink</Label>
    <Input
      type="url"
      id="flow-deepLink"
      className="flow-deeplink"
      onChange={e => onDeepLinkChange(e)}
      value={deepLink}
      name='deepLink'
      placeholder="http://domain.com"
    />
  </FormGroup>
);

FlowDeepLink.propTypes = propTypes;
FlowDeepLink.defaultProps = defaultProps;

export default FlowDeepLink;
